import { useFocusEffect } from "@react-navigation/native";
import { Button, Page } from "@towersystems/roam-common-native";
import React, { useCallback, useEffect } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { Colors } from "react-native-ui-lib";
import { useSetup2fa } from "../../../../utilities/2fa/hooks";
import { EnterMfaIdentifierFieldset } from "../../components/SetupNative2faForm/components/EnterMfaIdentifierFieldset";
import { useTranslation } from "../../../../utilities/i18n";

export interface Native2faEnterIdentifierScreenProps {}

export const Native2faEnterIdentifierScreen = ({ navigation }: any) => {
  const { t } = useTranslation("settings");
  const { handleOnSubmit } = useSetup2fa();
  const { control, handleSubmit, formState, getValues, reset } =
    useFormContext<any>();

  const { isLoading, isSubmitting, isValid, isSubmitSuccessful } = formState;

  const disabled = isLoading || isSubmitting || !isValid || isSubmitSuccessful;

  const codeSent = useWatch({ control, name: "ui.codeSent" });

  function handleComplete() {
    navigation.navigate("Native2faVerifyMfaCodeScreen");
  }

  useEffect(() => {
    if (!codeSent) return;
    handleComplete();
  }, [codeSent]);

  // undo any form state from future steps if we come back to this screen
  // it also resets the isSubmitSuccessful flag on the form ready
  // for a new submission
  useFocusEffect(
    useCallback(() => {
      const values = getValues();
      reset({
        ui: {
          ...values.ui,
          codeSent: false,
        },
        data: {
          ...values.data,
          password: undefined,
          code: undefined,
          identifier: undefined,
        },
      });
    }, [reset])
  );

  const footerMarkup = (
    <Button
      disabled={disabled}
      label={t("button.native_2fa_identifier")}
      loading={isSubmitting}
      backgroundColor={Colors.action}
      color="white"
      onPress={handleSubmit(handleOnSubmit)}
    ></Button>
  );

  return (
    <Page
      title={t("title.native_2fa_enter_identifier")}
      secondaryTitle={t("title.native_2fa_enter_identifier_secondary")}
      footer={footerMarkup}
    >
      <EnterMfaIdentifierFieldset />
    </Page>
  );
};
